function initModalViewers(modal) {
  modal.querySelectorAll(".modal__viewer[data-video-id]").forEach(function (el, idx) {
    if (el.dataset.initialized === "true") return;

    var videoId = el.getAttribute("data-video-id");
    if (!videoId) return;

    var modalId = modal.id || Math.random().toString(36).substr(2, 9);
    var containerId = "modal-s7viewer-" + modalId + "-" + idx;
    el.id = containerId;
    el.dataset.initialized = "true";

    var viewer = new s7viewers.VideoViewer({
      containerId: containerId,
      params: {
        asset: videoId,
        config: "bhsf/Video",
        serverurl: "https://s7d9.scene7.com/is/image/",
        contenturl: "https://s7d9.scene7.com/is/content/",
        videoserverurl: "https://s7d9.scene7.com/is/content",
        autoplay: "0", // Don't autoplay on init
        loop: "1",
        mute: "1",
        controls: "none"
      },
      handlers: {
        initComplete: function () {
          var player = viewer.videoplayer;
          if (player) player.play();
        }
      }
    });

    viewer.init();
    el.viewer = viewer;
  });
}

function playModalViewers(modal) {
  modal.querySelectorAll(".modal__viewer[data-video-id]").forEach(function (el) {
    if (el.viewer && el.viewer.videoplayer) {
      el.viewer.videoplayer.play();
    }
  });
}

function pauseModalViewers(modal) {
  modal.querySelectorAll(".modal__viewer[data-video-id]").forEach(function (el) {
    if (el.viewer && el.viewer.videoplayer) {
      el.viewer.videoplayer.pause();
    }
  });
}

// Resets the cursor state for in-page video players
function resetInPageVideoCursor() {
  document.querySelectorAll('.in-page-video-player__media-wrap.focused').forEach(mask => {
    mask.classList.remove('focused');
    mask.classList.add('unfocused');
    mask.style.cursor = ''; // Reset to default cursor
    mask.removeEventListener('mousemove', mask._positionCursor);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.js-video-modal-trigger[data-micromodal-trigger]').forEach(trigger => {
    const targetId = trigger.getAttribute('data-micromodal-trigger');
    const modal = document.getElementById(targetId);
    if (modal) {
      // Observe changes to modal visibility
      const observer = new MutationObserver(() => {
        if (modal.classList.contains('is-open')) {
          resetInPageVideoCursor();
          Scene7Loader.load(() => {
            initModalViewers(modal); // Initialize if not already
            playModalViewers(modal); // Play when opened
          });
        } else {
          pauseModalViewers(modal); // Pause when closed
        }
      });
      observer.observe(modal, { attributes: true, attributeFilter: ['class'] });
    }
  });
});